import { Web3ReactHooks } from "@web3-react/core";
import { MetaMask } from "@web3-react/metamask";
import { Network } from "@web3-react/network";
import { CoinbaseWallet } from "@web3-react/coinbase-wallet";
import { WalletConnect as WalletConnectV2 } from "@web3-react/walletconnect-v2";
import { AllChainIdEnum, ChainIdEnum } from "../../../enums/chain";
import { metaMask, hooks as metaMaskHooks } from "./metamask";
import { network, hooks as networkHooks } from "./network";
import {
  walletConnectV2,
  hooks as walletConnectV2Hooks,
} from "./walletConnectV2";
import { coinbaseWallet, hooks as coinbaseWalletHooks } from "./coinbaseWallet";

export enum WalletEnum {
  METAMASK = 1,
  WALLETCONNECT = 2,
  COINBASE = 3,
}

export const WALLET_NAMES = {
  [WalletEnum.METAMASK]: "Metamask",
  [WalletEnum.WALLETCONNECT]: "Wallet Connect",
  [WalletEnum.COINBASE]: "Coinbase Wallet",
};

export const supportedChainIds = [
  ...AllChainIdEnum.filter((v) => v !== ChainIdEnum.NONE),
];

const getSupportedChain = () => ChainIdEnum.ETH_MAINNET;

export const supportedChainId: ChainIdEnum = getSupportedChain();

export const allConnectors: [
  MetaMask | WalletConnectV2 | CoinbaseWallet | Network,
  Web3ReactHooks
][] = [
  [metaMask, metaMaskHooks],
  [walletConnectV2, walletConnectV2Hooks],
  [coinbaseWallet, coinbaseWalletHooks],
  [network, networkHooks],
];

export const walletToConnector: Record<
  WalletEnum,
  () => WalletConnectV2 | MetaMask | CoinbaseWallet | undefined
> = {
  [WalletEnum.METAMASK]: () => metaMask,
  [WalletEnum.WALLETCONNECT]: () => walletConnectV2,
  [WalletEnum.COINBASE]: () => coinbaseWallet,
};

export const LAST_CONNECTED_WALLET_LOCAL_STORAGE_KEY = "LAST_CONNECTED_WALLET";
